export default function SaptMeseriilor() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">SĂPTĂMÂNA MESERIILOR</h1>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-8">
          <p className="text-lg">
            Prin Legea nr. 66/2019 publicată în MONITORUL OFICIAL nr. 311 din 22
            aprilie 2019, ziua de 11 martie este instituită ca „Ziua Națională a
            Meseriilor”. Ministerul Educației, inspectoratele școlare,
            instituțiile de învățământ, precum și Parlamentul, Președinția
            României, Guvernul, celelalte autorități ale administrației publice
            centrale și locale organizează, cu ocazia Zilei Naționale a
            Meseriilor, evenimente educaționale pentru promovarea învățământului
            profesional și tehnic, precum și a meseriilor.
          </p>
        </div>
      </main>
    </div>
  );
}
